import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Box,
  Button,
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import theme from '../../styles/theme';

export default function SideNav({
  routes,
  accessLevel,
  accessType,
  customerType,
  isHidden,
}) {
  const [expandMobileMenu, setExpandMobileMenu] = useState(false);
  const mdAndUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box sx={{ position: 'relative' }}>
      <Collapse in={expandMobileMenu || mdAndUp}>
        <List disablePadding sx={{ marginBottom: 2 }}>
          {routes?.map((route, index) => {
            if (
              route?.path?.includes('company-profile') &&
              isHidden &&
              !(Number(accessLevel) === 3 && Number(accessType) === 3)
            ) {
              return null;
            }
            // Check if user has permission to view the item
            const restricted = route.accessLevel && route.accessType;
            const hasAccessLevelType =
              Number(accessLevel) >= Number(route.accessLevel) &&
              Number(accessType) >= Number(route.accessType);
            const hasCustomerType = route.customerType
              ? route.customerType === customerType
              : true;

            const showNavItem = restricted
              ? hasAccessLevelType && hasCustomerType
              : true;

            if (!showNavItem) return null;

            if (!route.path && route.label) {
              return (
                <ListItem
                  key={`label_${index}`}
                  sx={{
                    paddingTop: 2,
                    '&:not(:nth-of-type(1))': {
                      paddingTop: 3,
                    },
                  }}
                >
                  <ListItemText
                    primary={route.label}
                    sx={{
                      color: 'primary.main',
                      textTransform: 'uppercase',
                      '& .MuiListItemText-primary': {
                        fontSize: 16,
                      },
                    }}
                    slotProps={{ primary: { sx: { fontWeight: 700 } } }}
                  />
                </ListItem>
              );
            }

            return (
              <ListItem key={route.path} disablePadding>
                <ListItemButton
                  component={NavLink}
                  to={route.path}
                  sx={{
                    height: 50,
                    color: 'primary.main',
                    '&.active': {
                      backgroundColor: 'primary.main',
                    },
                  }}
                >
                  {route.icon && (
                    <ListItemIcon
                      sx={{
                        minWidth: 30,
                        color: 'primary.main',
                        '.active &': {
                          color: 'common.white',
                        },
                      }}
                    >
                      <Box sx={{ width: 20, height: 30 }}>{route.icon}</Box>
                    </ListItemIcon>
                  )}
                  <ListItemText
                    primary={route.label || route.path}
                    sx={{
                      color: 'primary.main',
                      '.active &': {
                        color: 'common.white',
                      },
                      '& .MuiListItemText-primary': {
                        fontSize: 16,
                      },
                    }}
                    slotProps={{ primary: { sx: { fontWeight: 700 } } }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Collapse>

      <Button
        startIcon={!expandMobileMenu ? <ExpandMore /> : <ExpandLess />}
        onClick={() => setExpandMobileMenu((state) => !state)}
        size="small"
        fullWidth
        sx={{
          backgroundColor: 'primary.light',
          borderRadius: 0,
          display: { md: 'none' },
        }}
      >
        Menu
      </Button>
    </Box>
  );
}
